
import { Box, Button, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotFound = () => (
  <>
    {/* <Head>
      <title>
        404 | Material Kit
      </title>
    </Head> */}
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        minHeight: '100%'
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            align="center"
            color="textPrimary"
            variant="h1"
          >
            404: Página no encontrada
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
          >
            <br></br>
            Hubo un error en la página que estaba buscando.
            <br></br>
            Es posible que la URL sea incorrecta o que la página haya sido eliminada.
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <img
              alt="Under development"
              src={`${process.env.PUBLIC_URL}/assets/images/undraw_page_not_found_su7k.svg`}
              style={{
                marginTop: 50,
                display: 'inline-block',
                maxWidth: '100%',
                width: 560
              }}
            />
          </Box>
          {/* <NextLink
            href="/"
            passHref
          > */}
            <Button
              component="a"
              startIcon={(<ArrowBackIcon fontSize="small" />)}
              sx={{ mt: 3 }}
              variant="contained"
            >
              Go back to dashboard
            </Button>
          {/* </NextLink> */}
        </Box>
      </Container>
    </Box>
  </>
);

export default NotFound;
